import React from 'react';

const MarketPanelIPOInsights = ({ data }) => {
  return (
    <div className="row">
      <div className="panel panel-default with-rounded-corner with-shadow p-10 w-100">
        <div className="panel-heading border-0">
          <span className="panel-title">IPO Insights</span>
        </div>
        <div className="panel-body">
          <table className="table table-condensed table-bordered bg-white" id="ipo-insights">
            <thead>
              <tr>
                <th>Company Name</th>
                <th>Issue Size (₹ Cr)</th>
                <th>Lot Size</th>
                <th>IPO Period</th>
                <th>Offer Price (₹)</th>
                <th>Listing Date</th>
                <th>Listing Price (₹)</th>
                <th>Current Price (₹)</th>
                <th>% Change</th>
                <th>Market Cap (₹ Cr)</th>
                <th>Outlook</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.company_name || '-'}</td>
                    <td>{item.issue_size || '-'}</td>
                    <td>{item.lot_size || '-'}</td>
                    <td>{item.ipo_period || '-'}</td>
                    <td>{item.offer_price || '-'}</td>
                    <td>{item.listing_date || '-'}</td>
                    <td>{item.listing_price || '-'}</td>
                    <td>{item.current_price || '-'}</td>
                    <td>{item.percent_change || '-'}</td>
                    <td>{item.market_cap || '-'}</td>
                    <td>{item.outlook || '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11" className="text-center">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MarketPanelIPOInsights;